import { ProductUsageCount } from '../../models/ProductUsageCount';
import { ProjectLink, ToolLink } from '../../models/ProjectLink';
import { ProvisioningOrder } from '../../models/ProvisioningOrder';
import { sanitizeExternalUrl } from '../../utils/urls';

export function isProductUsageCount(
  value: unknown,
): value is ProductUsageCount {
  const usageCount = value as ProductUsageCount | null;

  return (
    typeof usageCount === 'object' &&
    usageCount !== null &&
    typeof usageCount.catalogRefId === 'string' &&
    usageCount.catalogRefId.length > 0 &&
    typeof usageCount.count === 'number' &&
    Number.isFinite(usageCount.count)
  );
}

export function isProvisioningOrder(
  value: unknown,
): value is ProvisioningOrder {
  const order = value as ProvisioningOrder | null;

  return (
    typeof order === 'object' &&
    order !== null &&
    typeof order.instanceId === 'string' &&
    order.instanceId.length > 0 &&
    Array.isArray(order.provisioningResponses)
  );
}

export function isProjectLink(value: unknown): value is ProjectLink {
  const projectLink = value as ProjectLink | null;

  return (
    typeof projectLink === 'object' &&
    projectLink !== null &&
    typeof projectLink.toolId === 'string' &&
    Array.isArray(projectLink.links)
  );
}

export function sanitizeProjectLink(projectLink: ProjectLink): ProjectLink {
  const links = Array.isArray(projectLink.links) ? projectLink.links : [];

  return {
    ...projectLink,
    links: links.reduce<ToolLink[]>((safe, link) => {
      const uri = sanitizeExternalUrl(link?.uri);

      return uri ? [...safe, { ...link, uri }] : safe;
    }, []),
  };
}
